module.exports = __webpack_public_path__ + "static/media/favicon-32x32.1e7b35a7.svg";